<!-- Waiting on `getConversation`. Without this the whole panel is `*ngIf`'d away and the column is
     blank — indistinguishable from a group with no members, or from a broken screen. -->
<aside class="chat-info" *ngIf="!detail">
  <header class="chat-info__header">
    <span>Group Info</span>
    <button type="button" (click)="closed.emit()" aria-label="Close group info"><i class="pi pi-times"></i></button>
  </header>
  <p class="chat-info__loading"><i class="pi pi-spin pi-spinner"></i> Loading group…</p>
</aside>

<aside class="chat-info" *ngIf="detail as group">
  <header class="chat-info__header">
    <span>Group Info</span>
    <button type="button" (click)="closed.emit()" aria-label="Close group info"><i class="pi pi-times"></i></button>
  </header>

  <div class="chat-info__identity">
    <span class="chat-info__avatar"><i class="pi pi-users"></i></span>
    <h3>{{ group.name }}</h3>
    <p>{{ group.members.length }} member{{ group.members.length === 1 ? '' : 's' }}</p>
  </div>

  <div class="chat-info__actions">
    <!-- Owner-only, hidden entirely for members -->
    <button type="button" *ngIf="group.is_owner" (click)="manage.emit()"><i class="pi pi-pencil"></i> Edit Group</button>
    <button type="button" *ngIf="group.is_owner" (click)="addMembers.emit()"><i class="pi pi-user-plus"></i> Add Members</button>
    <button type="button" (click)="copyGroup()"><i class="pi pi-copy"></i> Copy Group</button>
    <button type="button" (click)="leaveGroup()"><i class="pi pi-sign-out"></i> Leave Group</button>
    <button type="button" class="is-danger" *ngIf="group.is_owner" (click)="deleteGroup()"><i class="pi pi-trash"></i> Delete Group</button>
  </div>

  <div class="chat-info__created" *ngIf="group.created_by">
    <span class="chat-info__label">Created by</span>
    <div class="chat-info__creator">
      <app-chat-avatar [name]="group.created_by.name" [size]="28"></app-chat-avatar>
      <div>
        <strong>{{ group.created_by.name }}</strong>
        <small>Created on {{ dayLabel(group.created_at) }}</small>
      </div>
    </div>
  </div>

  <div class="chat-info__members">
    <span class="chat-info__label">Members ({{ group.members.length }})</span>
    <ul>
      <li *ngFor="let member of group.members; trackBy: trackByMember" [class.is-inactive]="isInactive(member)">
        <app-chat-avatar [name]="member.name" [avatar]="member.avatar_url" [status]="member.status" [size]="32"></app-chat-avatar>
        <div class="chat-info__member-body">
          <span class="chat-info__member-name">
            {{ member.name }}
            <em *ngIf="isMe(member)">(You)</em>
          </span>
          <span class="chat-info__member-meta">
            <span class="chat-info__dot" [ngClass]="'is-' + member.status"></span>
            <!-- Deactivated wins over the role: "Group Admin" on someone who no longer has an
                 account is the wrong thing to lead with. -->
            {{ isInactive(member) ? statusLabel(member) : member.role === 'owner' ? 'Group Admin' : statusLabel(member) }}
          </span>
        </div>
        <button
          type="button"
          class="chat-info__remove"
          *ngIf="group.is_owner && !isMe(member)"
          (click)="removeMember(member)"
          [attr.aria-label]="'Remove ' + member.name">
          <i class="pi pi-user-minus"></i>
        </button>
      </li>
    </ul>
  </div>
</aside>
